// services/scoring.js
import { scoringWeights, healthScoreBoosts, healthScorePriority, HEALTH_SCORE_PRIORITY_DEFAULT } from '../config/config';

// Fonction pour calculer le boost Health Score (critère de qualité du compte)
const getHealthScoreBoost = (account) => {
  const accountData = account.parentcustomerid_account || account;
  const healthScoreCode = accountData?.dimsi_healthscore;

  // Retourner le boost basé sur le code Health Score, ou 0 si absent
  return healthScoreBoosts[healthScoreCode] || healthScoreBoosts[null] || 0.0;
};

// Fonction pour calculer le score d'un compte par rapport au prospect (contact-based search)
// Combine matching critères + Health Score boost
export const calculateScore = (account, prospectCriteria) => {
  let score = 0;
  const accountData = account.parentcustomerid_account || account;

  // 1. Calculer le score de matching sur les critères du prospect
  Object.keys(prospectCriteria).forEach(criterion => {
    let valueToCheck = accountData[criterion];
    if (criterion === 'dimsi_nbofemployees') {
      valueToCheck = account.dimsi_nbofemployees || accountData[criterion];
    }
    if (prospectCriteria[criterion] && valueToCheck === prospectCriteria[criterion]) {
      score += scoringWeights[criterion] || 0;
    }
  });

  // 2. Ajouter le boost Health Score (boost multiplicatif avec clamp à 1.0 max)
  const healthScoreBoost = getHealthScoreBoost(account);
  score = Math.min(1.0, score + (score * healthScoreBoost));

  return score;
};

// Trier les comptes par score décroissant (contact-based search)
export const sortAccountsByScore = (accounts, prospectCriteria) => {
  return accounts
    .map(account => ({
      ...account,
      score: calculateScore(account, prospectCriteria),
    }))
    .sort((a, b) => b.score - a.score);
};

// Obtenir la priorité Health Score d'un compte (lower = better)
const getHealthScorePriorityValue = (account) => {
  const accountData = account.parentcustomerid_account || account;
  const code = accountData?.dimsi_healthscore;
  if (code == null) return HEALTH_SCORE_PRIORITY_DEFAULT;
  return healthScorePriority[code] ?? HEALTH_SCORE_PRIORITY_DEFAULT;
};

// Trier les comptes par Health Score (meilleur en premier) pour la recherche avancée
export const sortAccountsByHealthScore = (accounts) => {
  return accounts
    .map(account => ({
      ...account,
      healthPriority: getHealthScorePriorityValue(account),
    }))
    .sort((a, b) => a.healthPriority - b.healthPriority);
};